import React from 'react';
import { CharacterListResponse } from '../../api/types';
import { ImAddressBook } from 'react-icons/im';
import styles from './WorldCharacterCard.module.css';

interface WorldCharacterCardProps {
  character: CharacterListResponse;
  onAddClick: (character: CharacterListResponse) => void;
  isSelected?: boolean;
  isAddingCharacter?: boolean;
  isLoading?: boolean;
}

const WorldCharacterCard: React.FC<WorldCharacterCardProps> = ({ 
  character, 
  onAddClick, 
  isSelected = false, 
  isAddingCharacter = false,
  isLoading = false
}) => {
  return (
    <div className={`${styles.card} ${isSelected ? styles.selected : ''} ${isAddingCharacter && isSelected ? styles.adding : ''}`}>
      <div className={styles.avatarContainer}>
        <img 
          src={character.icon} 
          alt={character.display_name} 
          className={styles.avatar}
        />
      </div>
      <div className={styles.contentContainer}>
        <h3 className={styles.name}>{character.display_name}</h3>
        <p className={styles.tagline}>{character.tagline}</p>
      </div>
      {isLoading ? (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner}></div>
        </div>
      ) : (
        <button 
          className={styles.addButton}
          onClick={() => onAddClick(character)}
          aria-label={`Add ${character.display_name}`}
          disabled={isAddingCharacter}
        >
          <ImAddressBook size={18} />
        </button>
      )}
    </div>
  );
};

export default WorldCharacterCard; 